module.exports = __webpack_public_path__ + "static/media/marie-rose-icon.855caafc.png";